import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import GenAI from 'src/scenes/GenAI';
import Status from 'src/scenes/Status';

const index = true;

export const genAIObject = inferRouteObject({
  path: 'gen-ai',
  element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: GenAI.Helmet,
      children: [
        { index, element: <Navigate to='./chat' replace /> },
        { path: 'chat', Component: GenAI.AiChat },
        {
          path: 'image',
          Component: GenAI.AiImageContext,
          children: [
            {
              path: ':modelOwner/:modelName/generate',
              children: [
                { index, Component: GenAI.AiImageGenerator },
                { path: ':taskId', Component: GenAI.AiImageGenerator },
              ],
            },
            { path: ':modelOwner/:modelName', Component: GenAI.AiImageModels },
            { index, element: <GenAI.AiImageModels /> },
          ],
        },
        {
          path: 'video',
          Component: GenAI.AiVideoContext,
          children: [
            {
              path: ':modelOwner/:modelName/generate',
              children: [
                { index, Component: GenAI.AiVideoGenerator },
                { path: ':taskId', Component: GenAI.AiVideoGenerator },
              ],
            },
            { path: ':modelOwner/:modelName', Component: GenAI.AiVideoModels },
            { index, element: <GenAI.AiVideoModels /> },
          ],
        },
      ],
    },
  ],
});
